import { render, staticRenderFns } from "./v-select1.vue?vue&type=template&id=1b8dd19a"
import script from "./v-select1.vue?vue&type=script&lang=js"
export * from "./v-select1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b8dd19a')) {
      api.createRecord('1b8dd19a', component.options)
    } else {
      api.reload('1b8dd19a', component.options)
    }
    module.hot.accept("./v-select1.vue?vue&type=template&id=1b8dd19a", function () {
      api.rerender('1b8dd19a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/select1/v-select1.vue"
export default component.exports